var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{staticClass:"form-control",attrs:{"value":_vm.value,"config":_vm.opt},on:{"input":function($event){return _vm.$emit('input', $event)},"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }